export default "__VITE_PUBLIC_ASSET__1c61a4da__"